<template>
  <v-card flat>
    <v-card-text>
      <CRow>
        <CCol sm="6" class="lg-card">
          <div class="value-card d-align">
            <div class="icon-div">
              <image-view
                :src="'/img/avatars/transfer.png'"
                class="mr-1"
              ></image-view>
            </div>
            <div class="ml-4">
              <h5>Total numbers</h5>
              <h5 class="text-success mb-0">
                {{ dashboardCount.total_count }}
              </h5>
            </div>
          </div>
        </CCol>
        <CCol sm="6" class="lg-card">
          <div class="value-card d-align">
            <div class="icon-div">
              <image-view
                :src="'/img/avatars/transfer.png'"
                class="mr-1"
              ></image-view>
            </div>
            <div class="ml-4">
              <h5>Total Revenue</h5>
              <h5 class="text-success mb-0">
                &#8377; {{ dashboardCount.total_revenue }}
              </h5>
            </div>
          </div>
        </CCol>
      </CRow>
      <!-- .......... -->
      <CRow>
        <CCol sm="6" v-for="plan in dashboardCount.plans" :key="plan._id">
          <h5>{{ plan.plan_name }} Plan</h5>
          <CRow>
            <CCol sm="6">
              <div class="value-card">
                <div class="d-flex mb-2">
                  <div class="icon-div">
                    <image-view
                      :src="'/img/avatars/transfer.png'"
                      class="mr-1"
                    ></image-view>
                  </div>
                  <div class="ml-4">
                    <h5>Total Number</h5>
                    <h5 class="text-success mb-0">{{ plan.count }}</h5>
                  </div>
                </div>
                <hr class="hr-line" />
                <div
                  class="d-just-space mb-3"
                  v-for="charge in plan.charges"
                  :key="charge.name"
                >
                  <div>
                    <h6 class="mb-0">{{ charge.name }}</h6>
                  </div>
                  <div>
                    <h6>{{ charge.count }}</h6>
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <div class="value-card">
                <div class="d-flex mb-2">
                  <div class="icon-div">
                    <image-view
                      :src="'/img/avatars/transfer.png'"
                      class="mr-1"
                    ></image-view>
                  </div>
                  <div class="ml-4">
                    <h5>Total Revenue</h5>
                    <h5 class="text-success mb-0">
                      &#8377; {{ plan.revenue }}
                    </h5>
                  </div>
                </div>
                <hr class="hr-line" />
                <div
                  class="d-just-space mb-3"
                  v-for="charge in plan.charges"
                  :key="charge.name"
                >
                  <div>
                    <h6 class="mb-0">{{ charge.name }}</h6>
                  </div>
                  <div>
                    <h6>&#8377; {{ charge.revenue }}</h6>
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <!-- .......... -->
    </v-card-text>
  </v-card>
</template>
<script>
const Image = () => import("@/components/image.vue");
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
export default {
  props: ["role", "date"],
  data() {
    return {
      dashboardCount: {},
    };
  },
  components: {
    ...pickSvg("crossSVG", "searchSVG"),
    "image-view": Image,
  },
  mounted() {
    this.accountMaster();
  },
  watch: {
    date: function () {
      this.accountMaster();
    },
  },
  methods: {
    accountMaster() {
      const params = {
        role: this.role,
      };
      if (this.date.start !== "") {
        (params.start_date = this.date.start.toISOString()),
          (params.end_date = this.date.end.toISOString());
      }
      let url = `${config.BASE_URL}api/v2/admin/subscription/master`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.dashboardCount = response.body.data;
        }
      });
    },
  },
};
</script>